import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const OnlyPublicRoute: React.FC = () => {
  const { signed, loadingSession } = useAuth();

  if (loadingSession) {
    return <></>;
  }

  return !signed ? <Outlet /> : <Navigate to="/clients" />;
};

export default OnlyPublicRoute;
